import Cookies from './Cookies';

const getCookieValue = function (cookieName) {
    if (!cookieName) return;
    const prefix = cookieName.substring(0, 9);
    if (prefix === 'livechat_') {
        cookieName = cookieName.substring(prefix.length, cookieName.length);
        return Cookies.get(`apexchat_${cookieName}`) || Cookies.get(`livechat_${cookieName}`);
    }
    return Cookies.get(cookieName);
};
export default getCookieValue;
